import {
  CalculusIndexEnum,
  GingivalIndexEnum,
  OcclusionEnum,
  OralStateEnum,
  PeriodontalDiseaseEnum,
  PlaqueIndexEnum,
  SkullTypeEnum
} from "requests";

export const OCCLUSION_DESCRIPTION_VALUES = {
  [OcclusionEnum.Normal]:
    "Normocclusion - perfect interdigitation of the upper and lower teeth. In the dog, the ideal tooth positions in the arches are defined by the occlusal, inter-arch and interdental relationships of the teeth of the archetypal carnivore.",
  [OcclusionEnum.Mal1]:
    "Class 1 Malocclusion (MAL1) - a normal rostrocaudal relationship of the upper and lower dental arches with malposition of one or more individual teeth.",
  [OcclusionEnum.Mal2]:
    "Class 2 Malocclusion – Mandibular Distoclusion (MAL2) - an abnormal rostrocaudal relationship between the dental arches in which the lower dental arch occludes caudal to its normal position relative to the upper dental arch.",
  [OcclusionEnum.Mal3]:
    "Class 3 Malocclusion – Mandibular Mesioclusion (MAL3) - an abnormal rostrocaudal relationship between the dental arches in which the lower dental arch occludes rostral to its normal position relative to the upper dental arch.",
  [OcclusionEnum.Mal4Rc]:
    "Class 4 Malocclusion – Maxillomandibular Asymmetry (MAL4/RC) - occurs when mandibular mesioclusion or distoclusion is present on one side of the face while the contralateral side retains normal dental alignment.",
  [OcclusionEnum.Mal4Dv]:
    "Class 4 Malocclusion – Maxillomandibular Asymmetry (MAL4/DV) - results in an open bite, which is defined as an abnormal vertical space between opposing dental arches when the mouth is closed.",
  [OcclusionEnum.Mal4Sts]:
    "Occlusion: Class 4 Malocclusion – Maxillomandibular Asymmetry (MAL4/STS) - in a side-to-side direction (MAL4/STS) occurs when there is loss of the midline alignment of the maxilla and mandible."
};

export const SKULL_TYPE_OPTIONS = [
  { label: "Brachycephalic", value: SkullTypeEnum.Brachycephalic },
  { label: "Mesocephalic", value: SkullTypeEnum.Mesocephalic },
  { label: "Dolichocephalic", value: SkullTypeEnum.Dolichocephalic }
];

export const ORAL_STATE_OPTIONS = [
  { label: "Normal", value: OralStateEnum.Normal },
  { label: "Abnormal", value: OralStateEnum.Abnormal }
];

export const ORAL_STATE_BOOLEAN_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

export const OCCLUSION_OPTIONS = [
  { label: "Normal", value: OcclusionEnum.Normal },
  { label: "MAL1", value: OcclusionEnum.Mal1 },
  { label: "MAL2", value: OcclusionEnum.Mal2 },
  { label: "MAL3", value: OcclusionEnum.Mal3 },
  { label: "MAL4/RC", value: OcclusionEnum.Mal4Rc },
  { label: "MAL4/DV", value: OcclusionEnum.Mal4Dv },
  { label: "MAL4/STS", value: OcclusionEnum.Mal4Sts }
];

export const PERIODONTAL_DISEASE_OPTIONS = [
  {
    label: "Periodontal Disease 0",
    value: PeriodontalDiseaseEnum.PeriodontalDisease_0
  },
  {
    label: "Periodontal Disease 1",
    value: PeriodontalDiseaseEnum.PeriodontalDisease_1
  },
  {
    label: "Periodontal Disease 2",
    value: PeriodontalDiseaseEnum.PeriodontalDisease_2
  },
  {
    label: "Periodontal Disease 3",
    value: PeriodontalDiseaseEnum.PeriodontalDisease_3
  },
  {
    label: "Periodontal Disease 4",
    value: PeriodontalDiseaseEnum.PeriodontalDisease_4
  }
];

export const PLAQUE_INDEX_OPTIONS = [
  { label: "Plaque Index 0", value: PlaqueIndexEnum.PlaqueIndex_0 },
  { label: "Plaque Index 1", value: PlaqueIndexEnum.PlaqueIndex_1 },
  { label: "Plaque Index 2", value: PlaqueIndexEnum.PlaqueIndex_2 },
  { label: "Plaque Index 3", value: PlaqueIndexEnum.PlaqueIndex_3 }
];

export const CALCULUS_INDEX_OPTIONS = [
  { label: "Calculus Index 0", value: CalculusIndexEnum.CalculusIndex_0 },
  { label: "Calculus Index 1", value: CalculusIndexEnum.CalculusIndex_1 },
  { label: "Calculus Index 2", value: CalculusIndexEnum.CalculusIndex_2 },
  { label: "Calculus Index 3", value: CalculusIndexEnum.CalculusIndex_3 }
];

export const GINGIVAL_INDEX = [
  { label: "Gingival Index 0", value: GingivalIndexEnum.GingivalIndex_0 },
  { label: "Gingival Index 1", value: GingivalIndexEnum.GingivalIndex_1 },
  { label: "Gingival Index 2", value: GingivalIndexEnum.GingivalIndex_2 },
  { label: "Gingival Index 3", value: GingivalIndexEnum.GingivalIndex_3 }
];
